import React, { useEffect, useState } from "react";
//Bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
//Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function PotentialIncomeTableRows({
  id,
  row,
  addRow,
  removeRow,
  setField,
  potentialIncomeRows,
}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (row.id === potentialIncomeRows[potentialIncomeRows.length - 1].id) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [potentialIncomeRows]);
  return (
    <tr key={id}>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <Form.Control
              type="text"
              className="incomeTableInput"
              placeholder="Title"
              value={row.title}
              onChange={(e) => setField("title", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeOne === 0
                  ? undefined
                  : row.potentialIncomeOne
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeOne", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeTwo === 0
                  ? undefined
                  : row.potentialIncomeTwo
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeTwo", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeThree === 0
                  ? undefined
                  : row.potentialIncomeThree
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeThree", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeFour === 0
                  ? undefined
                  : row.potentialIncomeFour
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeFour", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeFive === 0
                  ? undefined
                  : row.potentialIncomeFive
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeFive", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeSix === 0
                  ? undefined
                  : row.potentialIncomeSix
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeSix", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeSeven === 0
                  ? undefined
                  : row.potentialIncomeSeven
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeSeven", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeEight === 0
                  ? undefined
                  : row.potentialIncomeEight
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeEight", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeNine === 0
                  ? undefined
                  : row.potentialIncomeNine
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeNine", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeTen === 0
                  ? undefined
                  : row.potentialIncomeTen
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeTen", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeEleven === 0
                  ? undefined
                  : row.potentialIncomeEleven
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeEleven", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="incomeTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="incomeTableInput"
              value={
                row.potentialIncomeTwelve === 0
                  ? undefined
                  : row.potentialIncomeTwelve
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialIncomeTwelve", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td className="hideBorders col-1">
        {show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="incomeNavcolour me-3"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {!show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="incomeNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {show && (
          <Button
            onClick={() => {
              addRow(id);
              setShow(false);
            }}
            type="button"
            className="incomeNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faPlus} />
          </Button>
        )}
      </td>
    </tr>
  );
}
